import React, { useEffect } from 'react';
import type { Editor } from '@meitu/saas-editor-core';
import { type EventEmitter } from '@meitu/saas-editor-core/es/framework/services/events';
import { useNavigationCollapseStore } from '../../store/navigation-collapse-store';

export const RedirectToEvent = 'RedirectToEvent';

type IStageListScrollProps = {
    editor: Editor;
    events: EventEmitter;
};
export const StageListScroll = React.memo(({ editor, events }: IStageListScrollProps) => {
    useEffect(() => {
        const redirectToHandler = () => {
            navScrollToActiveIndex();
            editor.services.frame.scrollToActiveFrame();
        };

        const handler = events.on(RedirectToEvent, redirectToHandler);

        return () => {
            events.off(handler);
        };
    }, []);

    useEffect(() => {
        const handler = editor.services.frame.onActiveIndexChange(() => {
            const isClickingStage = useNavigationCollapseStore.getState().isClickingStage;
            const setIsClickingStage = useNavigationCollapseStore.getState().setIsClickingStage;
            if (isClickingStage) {
                setIsClickingStage(false);
                return;
            }
            navScrollToActiveIndex();
        });
        return () => editor.off(handler);
    }, []);

    const navScrollToActiveIndex = () => {
        const sizeList = editor.services.frame.getSizeList();
        const activeIndex = editor.services.frame.getActiveIndex();
        if (!sizeList.length) return;
        const stageNode = document.querySelectorAll('.c-navigation-collapse__item')?.[activeIndex] as HTMLElement;

        const offsetTop = stageNode?.offsetTop;
        if (offsetTop === undefined) return;

        document.querySelector('.c-navigation-collapse__list>div')?.scrollTo({
            top: offsetTop,
            behavior: 'smooth',
        });
        // events.emit(NAV_SCROLL_FRAME_EVENT);
    };

    return null;
});
